import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from 'react/jsx-runtime.js';
import { Card, DialogContent, DialogOverlay, DialogProvider, } from '@stepstone-genesis/components';
import { CloseModalButton } from './components/CloseModalButton.js';
export const FullscreenModalWrapper = ({ hideModal, isOpen, a11yLabel, children, }) => {
    return (_jsx(_Fragment, { children: _jsx(DialogProvider, { a11yLabel: a11yLabel, onDismiss: () => hideModal(false), isOpen: isOpen, isContentAnimatable: false, sx: {
                minWidth: ['100vw !important', null],
                minHeight: ['100vh'],
                margin: 'spaceNone',
                position: 'fixed',
                left: 'spaceNone',
                top: 'spaceNone',
                padding: '0px !important',
                '@supports (height: 100dvh)': {
                    minHeight: '100dvh',
                },
            }, children: _jsx(DialogOverlay, { sx: {
                    paddingLeft: 'spaceNone',
                    position: 'relative',
                    background: 'colorWhite',
                }, children: _jsx(DialogContent, { children: _jsxs(Card, { bg: 'colorWhite', sx: {
                            borderRadius: 'radiusNone',
                            height: '100vh',
                            minWidth: '100vw',
                            overflowY: 'auto',
                            '@supports (height: 100dvh)': {
                                height: '100dvh',
                            },
                        }, children: [_jsx(CloseModalButton, { onClick: () => hideModal(false) }), children] }) }) }) }) }));
};
//# sourceMappingURL=FullscreenModalWrapper.js.map